import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'
import * as types from './action-types'
import * as api from './api'

export default function* root() {
  yield takeLatestApiCall(types.SHIFT_ISSUES_FETCH_BEGIN, api.fetchShiftIssues)
}
